import React, { useEffect, useState } from "react";

const ThemeToggle = () => {
  const [theme, setTheme] = useState(null); // null initially

  useEffect(() => {
    // Read from localStorage only once client-side
    const storedTheme = localStorage.getItem("theme") || "light";
    setTheme(storedTheme);
  }, []);

  useEffect(() => {
    if (!theme) return; // Wait until theme is loaded
    document.documentElement.setAttribute("data-theme-transition", "");
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);

    const timeout = setTimeout(() => {
      document.documentElement.removeAttribute("data-theme-transition");
    }, 400);

    return () => clearTimeout(timeout);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => (prev === "light" ? "dark" : "light"));
  };

  // Prevent rendering until theme is known
  if (!theme) return null;

  return (
    <button
      onClick={toggleTheme}
      className="btn btn-outline-primary d-flex align-items-center"
      title="Toggle Theme"
      style={{ marginRight: "10px" }}
    >
      <i
        className={`ti ti-${theme === "light" ? "moon" : "sun"} theme-icon`}
        style={{
          transition: "transform 0.4s ease",
          transform: theme === "dark" ? "rotate(180deg)" : "rotate(0deg)",
        }}
      />
    </button>
  );
};

export default ThemeToggle;
